module.exports = __webpack_public_path__ + "application/templates/default/inner/subpoena/subpoena.template.html";